export default __webpack_public_path__ + "static/media/Background_00168.2dbe5b97.png";